<template>
  <div class="product">
    <el-row :gutter="20">
      <el-col :span="3" :xs="24">
        <div class="head-container">
          <el-tree :data="itemTypeOptions" :props="defaultProps" :expand-on-click-node="false" node-key="id"
                   default-expand-all
                   :filter-node-method="filterNode" ref="tree" @node-click="handleNodeClick"/>
        </div>
        <!--        :default-expanded-keys="expandedKey"-->
      </el-col>
      <el-col :span="21" :xs="24">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="商城方案" name="1"></el-tab-pane>
          <el-tab-pane label="店铺方案" name="0"></el-tab-pane>
        </el-tabs>
        <el-form size="mini" :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline">
          <el-form-item label="方案名称">
            <el-input size="mini" v-model="searchForm.title" placeholder="请输入方案名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="应用作物">
            <el-input size="mini" v-model="searchForm.searchCrop" placeholder="请输入作物名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="使用时期">
            <el-input size="mini" v-model="searchForm.searchPeriod" placeholder="请输入时期名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="防治对象">
            <el-input size="mini" v-model="searchForm.searchTarget" placeholder="请输入防治对象" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
            <el-button v-if="activeName === '1'" size="mini" type="primary" icon="el-icon-plus"
                       @click="onCropSolutionAdd">新增
            </el-button>
          </el-form-item>
        </el-form>
        <div class="product-content">
          <div class="table-wrap">
            <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
              <el-table-column prop="id" label="Id" width="50" align="center"></el-table-column>
              <el-table-column prop="solutionTitle" label="方案标题" min-width="100"
                               header-align="center"></el-table-column>
              <el-table-column prop="cropTxt" label="应用作物" width="150" align="center"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="periodTxt" label="防控时期" width="150" align="center"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="preventionTarget" label="防治对象" min-width="200" header-align="center"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="waterConsumption" label="容器水量" width="130px"
                               align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.waterConsumption }}{{ scope.row.unit }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="supplierName" label="创建店铺" width="160px" v-if="activeName === '0'"
                               align="center">

              </el-table-column>
              <!--              <el-table-column prop="solutionDesc" label="方案描述" min-width="160px" header-align="center"-->
              <!--                               show-overflow-tooltip></el-table-column>-->
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                  <el-button @click="gotoSolutionDetail(scope.row)" type="text" size="mini">详情
                  </el-button>
                  <el-button v-if="activeName === '1'" @click="onSolutionEditClick(scope.row)" type="text" size="mini">
                    编辑
                  </el-button>
                  <el-button v-if="activeName === '1'" @click="delSolutionClick(scope.row)" type="text" size="mini">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
    <!--    <solution-edit-dialog ref="solutionEditDialog" @solutionChange="getData"/>-->
  </div>
</template>

<script>
import CropSolutionApi from '@/api/cropsolution.js'
// import SolutionEditDialog from './component/solutionEditDialog'

export default {
  name: 'index',
  // components: {SolutionEditDialog},
  data () {
    return {
      activeName: '1',
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*是否正在加载*/
      loading: true,
      /*搜索参数*/
      searchForm: {
        title: '',
        searchCrop: '',
        searchPeriod: '',
        searchTarget: '',
        itemTypeId: 0
      },
      /*列表数据*/
      tableData: [],
      itemTypeOptions: undefined,
      defaultProps: {
        children: 'children',
        label: 'typeName'
      },
      // 部门树选项
      expandedKey: [],
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getSolutionType()
      this.getData()
    },
    getSolutionType () {
      let self = this
      CropSolutionApi.getCropSolutionType({}, true).then(res => {
        let cropTypeList = res.data || []
        self.itemTypeOptions = [{
          id: 0,
          typeName: '全部分类',
          children: cropTypeList
        }]
      }).catch(error => {
      })
    },
    getData () {
      let self = this
      let Params = self.searchForm
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.isSys = parseInt(self.activeName)
      self.loading = true
      CropSolutionApi.cropSolutionList(Params, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.records
          self.totalDataNumber = res.data.total
        })
        .catch(error => {
          self.loading = false
        })
    },

    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.getData()
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.loading = true
      self.curPage = val
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.pageSize = val
      this.getData()
    },
    onCropSolutionAdd () {
      // let editForm = {
      //   solutionTitle: '',
      //   coverId: 0,
      //   coverPath: '',
      //   cropList: [],
      //   periodList: [],
      //   preventionTargetList: [],
      //   solutionDesc: '',
      //   waterConsumption: undefined,
      //   remark: '',
      //   attachLists: [],
      //   cropSolutionProductList: []
      // }
      // this.$refs.solutionEditDialog.show(editForm)
      let to = {
        path: '/crop/solution/period/add'
      }
      if (this.searchForm.itemTypeId) {
        to.query = {
          type: this.searchForm.itemTypeId
        }
      }
      this.$router.push(to)
    },
    onSolutionEditClick (row) {
      // let editForm = JSON.parse(JSON.stringify(row))
      // this.$refs.solutionEditDialog.show(editForm)
      this.$router.push({
        path: '/crop/solution/period/edit',
        query: {
          solutionId: row.id
        }
      })
    },
    gotoSolutionDetail (row) {
      this.$router.push({
        path: '/crop/solution/period/detail',
        query: {
          solutionId: row.id
        }
      })
    },
    delSolutionClick (row) {
      let self = this
      self.$confirm('此操作将永久删除该方案, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.loading = true
        CropSolutionApi.deleteCropSolution({
          id: row.id
        }, true).then(data => {
          self.loading = false
          if (data.code == 1) {
            //刷新页面
            self.getData()
          } else {
            self.loading = false
          }
          self.$message(data.msg)
        }).catch(error => {
          self.loading = false
        })
      }).catch(() => {
      })
    },
    // 筛选节点
    filterNode (value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    // 节点单击事件
    handleNodeClick (data) {
      this.searchForm.itemTypeId = data.id
      this.getData()
    },
    /*切换菜单*/
    handleClick (tab, event) {
      let self = this
      self.curPage = 1
      self.getData()
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/crop/solution/period/index.vue